document.addEventListener("DOMContentLoaded", function () {
  // Elements
  const cartToggle = document.getElementById("cart-toggle");
  const cartDrawer = document.getElementById("cart-drawer");
  const cartOverlay = document.getElementById("cart-drawer-overlay");
  const closeButton = document.querySelector(".cart-drawer__close");
  const continueButtons = document.querySelectorAll(
    ".cart-drawer__button--continue"
  );

  // Open cart drawer
  function openCartDrawer() {
    cartDrawer.classList.add("active");
    cartOverlay.classList.add("active");
    document.body.style.overflow = "hidden";

    // Atualiza o conteúdo do carrinho ao abrir
    fetchCartAndUpdateUI();
  }

  // Close cart drawer
  function closeCartDrawer() {
    cartDrawer.classList.remove("active");
    cartOverlay.classList.remove("active");
    document.body.style.overflow = "";
  }

  // Make openCartDrawer available globally
  window.openCartSidebar = openCartDrawer;
  window.openCartDrawer = openCartDrawer;

  // Event listeners
  if (cartToggle) {
    cartToggle.addEventListener("click", openCartDrawer);
  }

  if (closeButton) {
    closeButton.addEventListener("click", closeCartDrawer);
  }

  if (cartOverlay) {
    cartOverlay.addEventListener("click", closeCartDrawer);
  }

  if (continueButtons.length > 0) {
    continueButtons.forEach((button) => {
      button.addEventListener("click", closeCartDrawer);
    });
  }

  // Fetch cart data and update UI
  function fetchCartAndUpdateUI() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        updateCartUI(cart);
        renderCartItems(cart);
      })
      .catch((error) => console.error("Error fetching cart:", error));
  }

  // Update cart UI
  function updateCartUI(cart) {
    // Update cart count
    const cartCount = document.querySelector(".header__cart-count");
    if (cartCount) {
      cartCount.textContent = cart.item_count;
    }

    // Update cart title
    const cartTitle = document.querySelector(".cart-drawer__title h2");
    if (cartTitle) {
      if (cart.item_count > 0) {
        cartTitle.textContent = `${cart.item_count} ${
          cart.item_count > 1 ? "itens" : "item"
        }`;
      } else {
        cartTitle.textContent = "sacola";
      }
    }

    // Calculate payment options
    if (cart.total_price > 0) {
      // Calculate PIX price (5% discount)
      const pixPrice = document.querySelector(".cart-drawer__pix-price");
      if (pixPrice) {
        pixPrice.textContent = formatMoney(cart.total_price * 0.95);
      }

      // Calculate installments with interest (2.19% per month)
      const maxInstallments = Math.min(10, Math.floor(cart.total_price / 5000));

      if (maxInstallments > 1) {
        const jurosAcumulado = maxInstallments * 0.0219; // 2.19% per month
        const fatorMultiplicador = 1 + jurosAcumulado;
        const valorTotalComJuros = cart.total_price * fatorMultiplicador;
        const valorParcela = valorTotalComJuros / maxInstallments;

        const installmentPrice = document.querySelector(
          ".cart-drawer__installment-price"
        );
        if (installmentPrice) {
          installmentPrice.textContent = `${maxInstallments}x de ${formatMoney(
            valorParcela
          )}`;
        }
      }
    }

    // Update cart content visibility
    const cartContent = document.querySelector(".cart-drawer__content");
    if (cartContent) {
      const emptyCartSection = document.querySelector(".cart-drawer__empty");
      const filledCartSection = document.querySelector(".cart-drawer__items");
      const notificationSection = document.querySelector(
        ".cart-drawer__notification"
      );
      const footerSection = document.querySelector(".cart-drawer__footer");

      if (cart.item_count === 0) {
        // Show empty cart state
        if (emptyCartSection) emptyCartSection.style.display = "flex";
        if (filledCartSection) filledCartSection.style.display = "none";
        if (notificationSection) notificationSection.style.display = "none";
        if (footerSection) footerSection.style.display = "none";
      } else {
        // Show filled cart state
        if (emptyCartSection) emptyCartSection.style.display = "none";
        if (filledCartSection) filledCartSection.style.display = "block";
        if (notificationSection) notificationSection.style.display = "block";
        if (footerSection) footerSection.style.display = "block";

        // Update subtotal
        const subtotalElement = document.querySelector(
          ".cart-drawer__subtotal span:last-child"
        );
        if (subtotalElement) {
          subtotalElement.textContent = formatMoney(cart.total_price);
        }
      }
    }
  }

  // Render cart items
  function renderCartItems(cart) {
    const cartItemsContainer = document.querySelector(".cart-drawer__items");
    if (!cartItemsContainer) return;

    // Clear current items
    cartItemsContainer.innerHTML = "";

    // Add new items
    cart.items.forEach((item) => {
      const itemElement = createCartItemElement(item);
      cartItemsContainer.appendChild(itemElement);
    });

    // Add event listeners to new elements
    attachCartItemEventListeners();
  }

  // Create cart item element
  function createCartItemElement(item) {
    const itemElement = document.createElement("div");
    itemElement.className = "cart-drawer__item";
    itemElement.setAttribute("data-item-id", item.id);
    itemElement.setAttribute("data-variant-id", item.variant_id);

    const imageUrl = item.image
      ? item.image.replace(/(\.[^.]*)$/, "_100x100$1")
      : "";

    itemElement.innerHTML = `
      <div class="cart-drawer__item-image">
        <img src="${imageUrl}" alt="${item.title}">
        <div class="loading-overlay">
          <div class="spinner"></div>
        </div>
      </div>
      <div class="cart-drawer__item-details">
        <h3 class="cart-drawer__item-title">${item.product_title}</h3>
        <p class="cart-drawer__item-variant">${item.variant_title || ""}</p>
        <p class="cart-drawer__item-price">${formatMoney(
          item.final_line_price
        )}</p>
        
        <div class="cart-drawer__item-quantity">
          <button class="cart-drawer__quantity-button cart-drawer__quantity-button--decrease" data-item-id="${
            item.id
          }">-</button>
          <input type="number" class="cart-drawer__quantity-input" value="${
            item.quantity
          }" min="1" data-item-id="${item.id}">
          <button class="cart-drawer__quantity-button cart-drawer__quantity-button--increase" data-item-id="${
            item.id
          }">+</button>
        </div>
      </div>
      <button class="cart-drawer__item-remove" data-item-id="${
        item.id
      }">Remover</button>
    `;

    return itemElement;
  }

  // Show loading state for a specific item
  function showItemLoading(itemId) {
    const itemImage = document.querySelector(
      `.cart-drawer__item[data-item-id="${itemId}"] .cart-drawer__item-image`
    );
    if (itemImage) {
      const loadingOverlay = itemImage.querySelector(".loading-overlay");
      if (loadingOverlay) {
        loadingOverlay.classList.add("active");
      }
    }
  }

  // Hide loading state for all items
  function hideAllLoadingStates() {
    const loadingOverlays = document.querySelectorAll(".loading-overlay");
    loadingOverlays.forEach((overlay) => {
      overlay.classList.remove("active");
    });
  }

  // Update cart item quantity with loading state
  function updateCartItemQuantity(itemId, quantity) {
    // Show loading state
    showItemLoading(itemId);

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: itemId,
        quantity: quantity,
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        // Hide loading state
        hideAllLoadingStates();

        updateCartUI(cart);
        renderCartItems(cart);
      })
      .catch((error) => {
        // Hide loading state even on error
        hideAllLoadingStates();
        console.error("Error updating cart:", error);
      });
  }

  // Attach event listeners to cart item elements
  function attachCartItemEventListeners() {
    // Quantity decrease buttons
    const decreaseButtons = document.querySelectorAll(
      ".cart-drawer__quantity-button--decrease"
    );
    decreaseButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const itemId = this.getAttribute("data-item-id");
        const input = document.querySelector(
          `.cart-drawer__quantity-input[data-item-id="${itemId}"]`
        );
        let quantity = parseInt(input.value) - 1;

        if (quantity >= 1) {
          updateCartItemQuantity(itemId, quantity);
        }
      });
    });

    // Quantity increase buttons
    const increaseButtons = document.querySelectorAll(
      ".cart-drawer__quantity-button--increase"
    );
    increaseButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const itemId = this.getAttribute("data-item-id");
        const input = document.querySelector(
          `.cart-drawer__quantity-input[data-item-id="${itemId}"]`
        );
        let quantity = parseInt(input.value) + 1;

        updateCartItemQuantity(itemId, quantity);
      });
    });

    // Quantity inputs
    const quantityInputs = document.querySelectorAll(
      ".cart-drawer__quantity-input"
    );
    quantityInputs.forEach((input) => {
      input.addEventListener("change", function () {
        const itemId = this.getAttribute("data-item-id");
        let quantity = parseInt(this.value);

        if (quantity < 1) {
          quantity = 1;
          this.value = 1;
        }

        updateCartItemQuantity(itemId, quantity);
      });
    });

    // Remove buttons
    const removeButtons = document.querySelectorAll(
      ".cart-drawer__item-remove"
    );
    removeButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const itemId = this.getAttribute("data-item-id");
        updateCartItemQuantity(itemId, 0);
      });
    });
  }

  // Format money
  function formatMoney(cents) {
    return "R$ " + (cents / 100).toFixed(2).replace(".", ",");
  }

  // Initialize cart drawer
  function initCartDrawer() {
    // Attach event listeners to existing elements
    attachCartItemEventListeners();

    // Listen for cart updates from other parts of the site
    document.addEventListener("cart:updated", function (event) {
      if (event.detail && event.detail.cart) {
        updateCartUI(event.detail.cart);
        renderCartItems(event.detail.cart);
      } else {
        fetchCartAndUpdateUI();
      }
    });
  }

  // Initialize
  initCartDrawer();
});
